import React from "react";
import ScanCard from "../components/dashboard/rfid/scancard";
import Dashboard from "../components/dashboard/dashboard";
import Addteacher from "../components/dashboard/teacher/addteacher";
import Addstudents from "../components/dashboard/student/addstudents";
import Promotestudent from "../components/dashboard/student/promotestudent";
import Leftstudent from "../components/dashboard/student/leftstudent";
import Allstudent from "../components/dashboard/student/allstudent";
import Studentbulkupload from "../components/dashboard/student/studentbulkupload";
import Deletestudent from "../components/dashboard/student/deletestudent";
import Category from "../components/dashboard/master/category";
import { Religion } from "../components/dashboard/master/religion";
import { Caste } from "../components/dashboard/master/caste";
import { SubCaste } from "../components/dashboard/master/subcaste";
import { Medium } from "../components/dashboard/master/medium";
import { AcademicYear } from "../components/dashboard/master/academicyear";
import { StudentClass } from "../components/dashboard/master/class";
import { StudentDivision } from "../components/dashboard/master/division";
import { Designation } from "../components/dashboard/master/designation";
import { Reporting } from "../components/dashboard/master/reporting";
import { Appointment } from "../components/dashboard/master/appointment";
import { Shift } from "../components/dashboard/master/shift";
import { Qualification } from "../components/dashboard/master/qualification";
import { TeacherDepartment } from "../components/dashboard/master/teacherdept";
import Allteachers from "../components/dashboard/teacher/allteachers";
import Leftteacher from "../components/dashboard/teacher/leftteacher";
import Addvisitors from "../components/dashboard/frontdesk/addvisitors";
import Allvisitors from "../components/dashboard/frontdesk/allvisitors";
import Addcomplaints from "../components/dashboard/complaints/addcomplaints";
import Allcomplaints from "../components/dashboard/complaints/allcomplaints";
import Applyleave from "../components/dashboard/leavemanagment/applyleave";
import Leavedashboard from "../components/dashboard/leavemanagment/leavedashboard";
import Leavedetails from "../components/dashboard/leavemanagment/leavedetails";
import Addidcard from "../components/dashboard/idcards/addidcard";
import Idcardbulkupload from "../components/dashboard/idcards/idcardbulkupload";
import Idcarddashboard from "../components/dashboard/idcards/idcarddashboard";
import Addfee from "../components/dashboard/feemodule/addfee";
import AllFee from "../components/dashboard/feemodule/allfee";
import FeeDashboard from "../components/dashboard/feemodule/feedashboard";
import Workersdashboard from "../components/dashboard/workers/workersdashboard";
import Addworkers from "../components/dashboard/workers/addworkers";
import Deleteworkers from "../components/dashboard/workers/deleteworkers";
import Workersbulkupload from "../components/dashboard/workers/workersbulkupload";
import Createexam from "../components/dashboard/exam/createexam";
import Createexamsubject from "../components/dashboard/exam/createexamsubject";
import Studentwisemarkenter from "../components/dashboard/exam/studentwisemarkenter";
import Classwisemarkupload from "../components/dashboard/exam/classwisemarkupload";
import Reportcarddetail from "../components/dashboard/exam/reportcarddetail";
import AddTimetable from "../components/dashboard/timetable/addtimetable";
import AllTimetable from "../components/dashboard/timetable/timetable";
import Addattendance from "../components/dashboard/attendance/addattedance";
import Allattendance from "../components/dashboard/attendance/allattendance";
import Homeworkdetail from "../components/dashboard/homework/homeworkdetail";
import Addhomework from "../components/dashboard/homework/addhomework";
import Addnotification from "../components/dashboard/notifications/Addnotification";
import Notificationlist from "../components/dashboard/notifications/notificationlist";
import Addacademy from "../components/dashboard/settings/addacademy";
import Addenquiry from "../components/dashboard/enquiry/addenquiry";
import Allenquiry from "../components/dashboard/enquiry/allenquiry";
import { FeeTypeMaster } from "../components/dashboard/master/feetypemaster";
import { FeeTypeMapping } from "../components/dashboard/master/feetypemapping";
import { Academylist } from "../components/dashboard/settings/academylist";
import Addvehicle from "../components/dashboard/transport/addvehicle";
import Vehicledashboard from "../components/dashboard/transport/vehicledashboard";
import Allalumini from "../components/dashboard/alumini/allalumini";
import Hostelvisitors from "../components/dashboard/hostel/hostelvisitors";
import Allhostelvisitors from "../components/dashboard/hostel/allhostelvisitors";
import AllhostelStudents from "../components/dashboard/hostel/allhostelstudents";
import Hostelstudentsbulkuploafds from "../components/dashboard/hostel/hostelstudentsbulkuploads";
import Feestructure from "../components/dashboard/feemodule/feestructure";
import Transportattendance from "../components/dashboard/transport/transportattendance";
import Alltransportattendance from "../components/dashboard/transport/alltransportattendance";
import Addincome from "../components/dashboard/incomeandexpence/addincome";
import Allincome from "../components/dashboard/incomeandexpence/allincome";
import Addcalendar from "../components/dashboard/calender/addcalendar";
import Sendsms from "../components/dashboard/communication/sendsms";
import Viewreport from "../components/dashboard/reports/examinationreport";
import { AcademyUser } from "../components/dashboard/settings/academyuser";
import { AcademyUserlist } from "../components/dashboard/settings/academyuserlist";
import RoleList from "../components/dashboard/settings/rolelist";
import ReasonList from "../components/dashboard/settings/reasonlist";
import { Subject } from "../components/dashboard/master/subject";
import Allexamsubject from "../components/dashboard/exam/allexamsubject";
import Teacherbulkupload from "../components/dashboard/teacher/teacherbulkupload";
import { WorkerType } from "../components/dashboard/workers/workertype";
import { VehicleType } from "../components/dashboard/transport/vehicletype";
import { VehicleRoute } from "../components/dashboard/transport/vehicleroute";
import Vehiclelist from "../components/dashboard/transport/vehiclelist";
import { ChangeRoute } from "../components/dashboard/transport/changeroute";
import { VehicleTrip } from "../components/dashboard/transport/vehicletrip";
import Listcalendar from "../components/dashboard/calender/listcalendar";
import { IncExpHead } from "../components/dashboard/incomeandexpence/incexphead";
import { FeeList } from "../components/dashboard/feemodule/feelist";
import { Invoice } from "../components/dashboard/feemodule/invoice";
import { BedTypeMaster } from "../components/dashboard/hostel/bedtype";
import { RoomNoMaster } from "../components/dashboard/hostel/roomlist";
import { HostelMaster } from "../components/dashboard/hostel/hostellist";
import { LeftHostel } from "../components/dashboard/hostel/lefthostel";
import { VisitorCategoryMaster } from "../components/dashboard/hostel/visitorcategory";
import SuperAdminDashboard from "../components/dashboard/superadmindashboard";
import RolePermission from "../components/dashboard/settings/rolePermission";
import EditRolePermission from "../components/dashboard/settings/editRolePermission";
import Teacherdashboard from "../components/dashboard/teacherdashboard";
import Studentdashboard from "../components/dashboard/studentdashboard";
import Workersdeskdashboard from "../components/dashboard/workersdashboard";
import Wardendashboard from "../components/dashboard/wardendashboard";
import Accountsdashboard from "../components/dashboard/accountsdashboard";
import Driverdashboard from "../components/dashboard/driverdashboard";
import Frontdeskdashboard from "../components/dashboard/frontdeskdashboard";
import Studentmyprofile from "../components/dashboard/myprofile/studentmyprofile";
import Teachermyprofile from "../components/dashboard/myprofile/teachermyprofile";
import Workersmyprofile from "../components/dashboard/myprofile/workersmyprofile";
import StudentReport from "../components/dashboard/reports/studentreport";
import ExaminationReport from "../components/dashboard/reports/examinationreport";
import SettingDefault from "../components/dashboard/settings/settingdefault";
import AllIncome from "../components/dashboard/incomeandexpence/allincome";
import { IncomeDashboard } from "../components/dashboard/incomeandexpence/incomedashboard";
import CertificateList from "../components/dashboard/certificate/certlist";
import CertificateUpload from "../components/dashboard/certificate/certupload";
import { SlotManagement } from "../components/dashboard/timetable/slots";
import AllTimetableSlot from "../components/dashboard/timetable/timetableslot";
import { CredentialReport } from "../components/dashboard/reports/credentialreport";
import SalaryComponents from "../components/dashboard/payroll/salarycomponents";
import SalaryStructure   from "../components/dashboard/payroll/salarystructure";
import GeneratePayroll   from "../components/dashboard/payroll/generatepayroll";
import PayrollList       from "../components/dashboard/payroll/payrolllist";
import SalaryAdvance     from "../components/dashboard/payroll/salaryadvance";
import AdvanceList       from "../components/dashboard/payroll/advancelist";
import SalaryRegister    from "../components/dashboard/payroll/salaryregister";
import AccountGroups from "../components/dashboard/accounts/accountgroups";
import LedgerMaster from "../components/dashboard/accounts/ledgermaster";
import VoucherEntry from "../components/dashboard/accounts/voucherentry";
import VoucherList from "../components/dashboard/accounts/voucherlist";
import DayBook from "../components/dashboard/accounts/daybook";
import LedgerReport from "../components/dashboard/accounts/ledgerreport";
import TrialBalance from "../components/dashboard/accounts/trialbalance";
import ProfitLoss from "../components/dashboard/accounts/profitloss";
import BalanceSheet from "../components/dashboard/accounts/balancesheet";
import { FeePosting } from "../components/dashboard/feemodule/feeposting";
import FeeReport from "../components/dashboard/reports/feereport";
import FeePaymentReport from "../components/dashboard/reports/feepaymentreport";
import MasterReport from "../components/dashboard/reports/masterreport";
import TimetableReport from "../components/dashboard/reports/timetablereport";
import IdCardReport from "../components/dashboard/reports/idcardreport";
import AluminiReport from "../components/dashboard/reports/aluminireport";
import WorkerReport from "../components/dashboard/reports/workerreport";
import VisitorReport from "../components/dashboard/reports/visitorreport";
import ComplaintReport from "../components/dashboard/reports/complaintreport";
import AdmissionEnquiryReport from "../components/dashboard/reports/admissionenquiryreport";
import HostelReport from "../components/dashboard/reports/hostelreport";
import CalendarReport from "../components/dashboard/reports/calendarreport";
import CircularReport from "../components/dashboard/reports/circularreport";
import CertificateReport from "../components/dashboard/reports/certificatereport";
import GenerateCertificate from "../components/dashboard/certificates/generatecertificate";
import Bulkexamupload from "../components/dashboard/exam/bulkexamupload";
import { VehicleStage } from "../components/dashboard/transport/vehiclestage";
import ListSms from "../components/dashboard/communication/listsms";
import Audiosms from "../components/dashboard/communication/audiosms";
import AudioNotificationList from "../components/dashboard/communication/audionotificationlist";
import Classwiseattendance from "../components/dashboard/attendance/classwiseattendance";
export const dashboardroutes = [
  {
    id: 1,
    path: "/superadmin/dashboard",
    exact: false,
    element: <SuperAdminDashboard />,
  },
  {
    id: 2,
    path: "/student/addstudents",
    exact: false,
    element: <Addstudents />,
  },
  {
    id: 3,
    path: "/student/promotestudent",
    exact: false,
    element: <Promotestudent />,
  },
  {
    id: 4,
    path: "/student/studentdetail/:id",
    exact: false,
    element: <Addstudents />,
  },
  {
    id: 5,
    path: "/student/leftstudentlist",
    exact: false,
    element: <Allstudent />,
  },
  {
    id: 6,
    path: "/student/leftstudent",
    exact: false,
    element: <Leftstudent />,
  },
  {
    id: 7,
    path: "/student/allstudent",
    exact: false,
    element: <Allstudent />,
  },
  {
    id: 8,
    path: "/student/studentbulkupload",
    exact: false,
    element: <Studentbulkupload />,
  },
  {
    id: 9,
    path: "/student/deletestudent",
    exact: false,
    element: <Deletestudent />,
  },
  {
    id: 10,
    path: "/student/deletestudentlist",
    exact: false,
    element: <Allstudent />,
  },
  {
    id: 11,
    path: "/teacher/addteacher",
    exact: false,
    element: <Addteacher />,
  },

  {
    id: 12,
    path: "/master/category",
    exact: false,
    element: <Category />,
  },
  {
    id: 13,
    path: "/master/religion",
    exact: false,
    element: <Religion />,
  },
  {
    id: 14,
    path: "/master/caste",
    exact: false,
    element: <Caste />,
  },
  {
    id: 15,
    path: "/master/subcaste",
    exact: false,
    element: <SubCaste />,
  },
  {
    id: 16,
    path: "/master/previousmedium",
    exact: false,
    element: <Medium />,
  },
  {
    id: 17,
    path: "/master/academicyear",
    exact: false,
    element: <AcademicYear />,
  },
  {
    id: 18,
    path: "/master/class",
    exact: false,
    element: <StudentClass />,
  },
  {
    id: 19,
    path: "/master/section",
    exact: false,
    element: <StudentDivision />,
  },
  {
    id: 20,
    path: "/master/department",
    exact: false,
    element: <TeacherDepartment />,
  },
  {
    id: 21,
    path: "/master/designation",
    exact: false,
    element: <Designation />,
  },
  {
    id: 22,
    path: "/master/reporting",
    exact: false,
    element: <Reporting />,
  },
  {
    id: 23,
    path: "/master/appointmenttype",
    exact: false,
    element: <Appointment />,
  },
  {
    id: 24,
    path: "/master/shift",
    exact: false,
    element: <Shift />,
  },
  {
    id: 25,
    path: "/master/qualification",
    exact: false,
    element: <Qualification />,
  },
  {
    id: 26,
    path: "/teacher/allteacher",
    exact: false,
    element: <Allteachers />,
  },
  {
    id: 27,
    path: "/teacher/teacherdetail/:id",
    exact: false,
    element: <Addteacher />,
  },
  {
    id: 28,
    path: "/teacher/deleteteacherlist",
    exact: false,
    element: <Allteachers />,
  },

  {
    id: 29,
    path: "/teacher/leftteacherlist",
    exact: false,
    element: <Allteachers />,
  },

  {
    id: 30,
    path: "/teacher/deleteteacher",
    exact: false,
    element: <Leftteacher />,
  },
  {
    id: 31,
    path: "/teacher/bulkuploadteacher",
    exact: false,
    element: <Leftteacher />,
  },
  {
    id: 32,
    path: "/teacher/leftteacher",
    exact: false,
    element: <Leftteacher />,
  },
  {
    id: 33,
    path: "/frontdesk/addvisitors",
    exact: false,
    element: <Addvisitors />,
  },
  {
    id: 34,
    path: "/frontdesk/allvisitors",
    exact: false,
    element: <Allvisitors />,
  },
  {
    id: 35,
    path: "/frontdesk/deletevisitor",
    exact: false,
    element: <Allvisitors />,
  },
  {
    id: 36,
    path: "/frontdesk/visitordetail/:id",
    exact: false,
    element: <Addvisitors />,
  },
  {
    id: 37,
    path: "/complaints/addcomplaint",
    exact: false,
    element: <Addcomplaints />,
  },
  {
    id: 38,
    path: "/complaints/complaintdetail/:id",
    exact: false,
    element: <Addcomplaints />,
  },
  {
    id: 39,
    path: "/complaints/allcomplaints",
    exact: false,
    element: <Allcomplaints />,
  },
  {
    id: 40,
    path: "/complaints/deletecomplaints",
    exact: false,
    element: <Allcomplaints />,
  },
  {
    id: 41,
    path: "/leavemanagement/leavedashboard",
    exact: false,
    element: <Leavedashboard />,
  },
  {
    id: 42,
    path: "/leavemanagement/applyleave",
    exact: false,
    element: <Applyleave />,
  },
  {
    id: 43,
    path: "/leavemanagement/allleave",
    exact: false,
    element: <Leavedetails />,
  },
  {
    id: 44,
    path: "/idcards/idcarddashboard",
    exact: false,
    element: <Idcarddashboard />,
  },
  {
    id: 45,
    path: "/idcards/idcardbulkupload",
    exact: false,
    element: <Idcardbulkupload />,
  },
  {
    id: 46,
    path: "/idcards/addidcard",
    exact: false,
    element: <Addidcard />,
  },
  {
    id: 47,
    path: "/feemodule/addfee",
    exact: false,
    element: <Addfee />,
  },
  {
    id: 48,
    path: "/feemodule/invoice/:id/:eid",
    exact: false,
    element: <Invoice />,
  },
  {
    id: 49,
    path: "/feemodule/allfee",
    exact: false,
    element: <AllFee />,
  },
  {
    id: 186,
    path: "/feemodule/feedashboard",
    exact: false,
    element: <FeeDashboard />,
  },
  {
    id: 50,
    path: "/transport/vehicledashboard",
    exact: false,
    element: <Vehicledashboard />,
  },
  {
    id: 51,
    path: "/transport/addvehicle",
    exact: false,
    element: <Addvehicle />,
  },
  {
    id: 52,
    path: "/workers/workersdashboard",
    exact: false,
    element: <Workersdashboard />,
  },
  {
    id: 53,
    path: "/workers/addworkers",
    exact: false,
    element: <Addworkers />,
  },
  {
    id: 54,
    path: "/workers/workerlist",
    exact: false,
    element: <Deleteworkers />,
  },
  {
    id: 55,
    path: "/workers/deleteworkers",
    exact: false,
    element: <Deleteworkers />,
  },
  {
    id: 56,
    path: "/workers/workersbulkupload",
    exact: false,
    element: <Workersbulkupload />,
  },
  {
    id: 57,
    path: "/exam/createexam",
    exact: false,
    element: <Createexam />,
  },
  {
    id: 58,
    path: "/exam/createexamsubject",
    exact: false,
    element: <Createexamsubject />,
  },
  {
    id: 59,
    path: "/exam/studentwisemarkenter",
    exact: false,
    element: <Studentwisemarkenter />,
  },
  {
    id: 60,
    path: "/exam/classwisemarkupload",
    exact: false,
    element: <Classwisemarkupload />,
  },
  {
    id: 61,
    path: "/exam/reportcarddetail",
    exact: false,
    element: <Reportcarddetail />,
  },
  {
    id: 62,
    path: "/timetable/addtimetable",
    exact: false,
    element: <AddTimetable />,
  },

  {
    id: 64,
    path: "/timetable/alltimetable",
    exact: false,
    element: <AllTimetableSlot />,
  },
  {
    id: 65,
    path: "/attendance/addattendance",
    exact: false,
    element: <Addattendance />,
  },
  {
    id: 66,
    path: "/attendance/allattendance",
    exact: false,
    element: <Allattendance />,
  },
  {
    id: 67,
    path: "/homework/addhomework",
    exact: false,
    element: <Addhomework />,
  },
  {
    id: 68,
    path: "/homework/allhomework",
    exact: false,
    element: <Homeworkdetail />,
  },
  {
    id: 69,
    path: "/homework/homeworkdetail/:id",
    exact: false,
    element: <Addhomework />,
  },
  {
    id: 70,
    path: "/circular/addcircular",
    exact: false,
    element: <Addnotification />,
  },
  {
    id: 71,
    path: "/circular/circularlist",
    exact: false,
    element: <Notificationlist />,
  },
  {
    id: 72,
    path: "/settings/addacademy",
    exact: false,
    element: <Addacademy />,
  },
  {
    id: 73,
    path: "/settings/allacademy",
    exact: false,
    element: <Academylist />,
  },
  {
    id: 74,
    path: "/enquiry/addenquiry",
    exact: false,
    element: <Addenquiry />,
  },
  {
    id: 75,
    path: "/enquiry/allenquiry",
    exact: false,
    element: <Allenquiry />,
  },
  {
    id: 76,
    path: "/enquiry/deleteenquiry",
    exact: false,
    element: <Allenquiry />,
  },
  {
    id: 77,
    path: "/alumni/allalumni",
    exact: false,
    element: <Allalumini />,
  },

  {
    id: 78,
    path: "/hostel/hostelvisitors",
    exact: false,
    element: <Hostelvisitors />,
  },
  {
    id: 79,
    path: "/hostel/allhostelvisitors",
    exact: false,
    element: <Allhostelvisitors />,
  },
  {
    id: 79,
    path: "/hostel/allhostelstudents",
    exact: false,
    element: <AllhostelStudents />,
  },
  {
    id: 80,
    path: "/hostel/hostelstudentsbulkuploads",
    exact: false,
    element: <Hostelstudentsbulkuploafds />,
  },
  {
    id: 81,
    path: "/hostel/lefthostelstudents",
    exact: false,
    element: <AllhostelStudents />,
  },
  {
    id: 82,
    path: "/feemodule/feestructure",
    exact: false,
    element: <Feestructure />,
  },
  {
    id: 83,
    path: "/transport/driverattendance",
    exact: false,
    element: <Transportattendance />,
  },
  {
    id: 84,
    path: "/transport/addattendance",
    exact: false,
    element: <Alltransportattendance />,
  },
  {
    id: 85,
    path: "/incomeandexpense/addincome",
    exact: false,
    element: <Addincome />,
  },
  {
    id: 86,
    path: "/incomeandexpense/deleteincome",
    exact: false,
    element: <AllIncome />,
  },
  {
    id: 87,
    path: "/incomeandexpense/addexpenses",
    exact: false,
    element: <Addincome />,
  },
  {
    id: 89,
    path: "/transport/vehicledetail/:id",
    exact: false,
    element: <Addvehicle />,
  },
  {
    id: 90,
    path: "/calender/addcalendar",
    exact: false,
    element: <Listcalendar />,
  },
  {
    id: 92,
    path: "/communication/sendsms",
    exact: false,
    element: <Sendsms />,
  },
  {
    id: 93,
    path: "/reports/studentreport",
    exact: false,
    element: <StudentReport />,
  },
  {
    id: 94,
    path: "/master/feetype",
    exact: false,
    element: <FeeTypeMaster />,
  },
  {
    id: 1571,
    path: "/master/feetypemapping",
    exact: false,
    element: <FeeTypeMapping />,
  },
  {
    id: 95,
    path: "/leavemanagement/leavedetail/:id",
    exact: false,
    element: <Applyleave />,
  },
  {
    id: 96,
    path: "/settings/academydetail/:id",
    exact: false,
    element: <Addacademy />,
  },
  {
    id: 97,
    path: "/settings/academyuser",
    exact: false,
    element: <AcademyUser />,
  },
  {
    id: 98,
    path: "/settings/academyuserlist",
    exact: false,
    element: <AcademyUserlist />,
  },
  {
    id: 99,
    path: "/settings/academyuserdetail/:id",
    exact: false,
    element: <AcademyUser />,
  },
  {
    id: 100,
    path: "/settings/rolelist",
    exact: false,
    element: <RoleList />,
  },
  {
    id: 101,
    path: "/settings/reasonlist",
    exact: false,
    element: <ReasonList />,
  },
  {
    id: 102,
    path: "/master/subject",
    exact: false,
    element: <Subject />,
  },
  {
    id: 103,
    path: "/student/dashboard",
    exact: false,
    element: <Studentdashboard />,
  },
  {
    id: 104,
    path: "/teacher/dashboard",
    exact: false,
    element: <Teacherdashboard />,
  },
  {
    id: 105,
    path: "/exam/listallexams",
    exact: false,
    element: <Allexamsubject />,
  },
  {
    id: 106,
    path: "/exam/deleteexamlist",
    exact: false,
    element: <Allexamsubject />,
  },
  {
    id: 107,
    path: "/exam/examsubjectdetail/:id",
    exact: false,
    element: <Createexamsubject />,
  },
  {
    id: 108,
    path: "/teacher/teacherbulkupload",
    exact: false,
    element: <Teacherbulkupload />,
  },
  {
    id: 109,
    path: "/enquiry/enquirydetail/:id",
    exact: false,
    element: <Addenquiry />,
  },
  {
    id: 110,
    path: "/workers/workertype",
    exact: false,
    element: <WorkerType />,
  },
  {
    id: 111,
    path: "/workers/workerdetail/:id",
    exact: false,
    element: <Addworkers />,
  },
  {
    id: 112,
    path: "/transport/vehicletype",
    exact: false,
    element: <VehicleType />,
  },
  {
    id: 113,
    path: "/transport/vehicleroute",
    exact: false,
    element: <VehicleRoute />,
  },
  {
    id: 114,
    path: "/transport/vehiclelist",
    exact: false,
    element: <Vehiclelist />,
  },
  {
    id: 115,
    path: "/transport/deletevehiclelist",
    exact: false,
    element: <Vehiclelist />,
  },
  {
    id: 116,
    path: "/transport/changeroute",
    exact: false,
    element: <ChangeRoute />,
  },
  {
    id: 117,
    path: "/transport/vehicletrip",
    exact: false,
    element: <VehicleTrip />,
  },
  {
    id: 118,
    path: "/calender/calendarevents",
    exact: false,
    element: <Addcalendar />,
  },
  {
    id: 119,
    path: "/incomeandexpense/addincomehead",
    exact: false,
    element: <IncExpHead />,
  },
  {
    id: 120,
    path: "/incomeandexpense/addexpensehead",
    exact: false,
    element: <IncExpHead />,
  },
  {
    id: 121,
    path: "/feemodule/feesummary/:id",
    exact: false,
    element: <FeeList />,
  },
  {
    id: 122,
    path: "/hostel/hostellist",
    exact: false,
    element: <HostelMaster />,
  },
  {
    id: 123,
    path: "/hostel/roomtypelist",
    exact: false,
    element: <BedTypeMaster />,
  },
  {
    id: 124,
    path: "/hostel/roomlist",
    exact: false,
    element: <RoomNoMaster />,
  },
  {
    id: 125,
    path: "/hostel/lefthostellist",
    exact: false,
    element: <LeftHostel />,
  },
  {
    id: 126,
    path: "/hostel/categorylist",
    exact: false,
    element: <VisitorCategoryMaster />,
  },
  {
    id: 127,
    path: "/hostel/hostelvisitorsdetail/:id",
    exact: false,
    element: <Hostelvisitors />,
  },
  {
    id: 128,
    path: "/superadmin/superdashboard",
    exact: false,
    element: <SuperAdminDashboard />,
  },
  {
    id: 129,
    path: "/settings/rolepermission",
    exact: false,
    element: <RolePermission />,
  },
  {
    id: 130,
    path: "/settings/edit-role-permission/:id",
    exact: false,
    element: <EditRolePermission />,
  },
  {
    id: 131,
    path: "/workers/dashboard",
    exact: false,
    element: <Workersdeskdashboard />,
  },
  {
    id: 132,
    path: "/accounts/dashboard",
    exact: false,
    element: <Accountsdashboard />,
  },
  {
    id: 133,
    path: "/warden/dashboard",
    exact: false,
    element: <Wardendashboard />,
  },
  {
    id: 134,
    path: "/driver/dashboard",
    exact: false,
    element: <Driverdashboard />,
  },
  {
    id: 135,
    path: "/frontdesk/dashboard",
    exact: false,
    element: <Frontdeskdashboard />,
  },
  {
    id: 136,
    path: "/student/profile/:id",
    exact: false,
    element: <Studentmyprofile />,
  },
  {
    id: 137,
    path: "/teacher/profile/:id",
    exact: false,
    element: <Teachermyprofile />,
  },
  {
    id: 138,
    path: "/workers/profile/:id",
    exact: false,
    element: <Workersmyprofile />,
  },
  {
    id: 139,
    path: "/reports/admissionreport",
    exact: false,
    element: <StudentReport />,
  },
  {
    id: 139,
    path: "/reports/attendancereport",
    exact: false,
    element: <Allattendance />,
  },
  {
    id: 140,
    path: "/reports/homeworkreport",
    exact: false,
    element: <Homeworkdetail />,
  },
  {
    id: 141,
    path: "/reports/examinationreport",
    exact: false,
    element: <ExaminationReport />,
  },
  {
    id: 142,
    path: "/reports/teacherreport",
    exact: false,
    element: <Allteachers />,
  },
  {
    id: 143,
    path: "/reports/leavereport",
    exact: false,
    element: <Leavedetails />,
  },
  {
    id: 144,
    path: "/settings/defaultsetting",
    exact: false,
    element: <SettingDefault />,
  },
  {
    id: 145,
    path: "/incomeandexpense/deleteexpenses",
    exact: false,
    element: <AllIncome />,
  },
  {
    id: 146,
    path: "/incomeandexpense/allincome",
    exact: false,
    element: <IncomeDashboard />,
  },
  
  {
    id: 147,
    path: "/certificate/certificatelist",
    exact: false,
    element: <CertificateList />,
  },
  {
    id: 148,
    path: "/certificate/uploadcertificate/:id",
    exact: false,
    element: <CertificateUpload />,
  },
  {
    id: 149,
    path: "/homework/viewhomework/:id",
    exact: false,
    element: <Addhomework />,
  },
  {
    id: 150,
    path: "/reports/dobreport",
    exact: false,
    element: <StudentReport />,
  },
  {
    id: 151,
    path: "/master/slotslist",
    exact: false,
    element: <SlotManagement />,
  },
  {
    id: 152,
    path: "/reports/credentialreport",
    exact: false,
    element: <CredentialReport />,
  },
  {
    id: 153,
    path: "/feemodule/feeposting",
    exact: false,
    element: <FeePosting />,
  },
  {
    id: 154,
    path: "/reports/transportreport",
    exact: false,
    element: <Transportattendance />,
  },
  {
    id: 155,
    path: "/reports/feereport",
    exact: false,
    element: <FeeReport />,
  },
  {
    id: 1560,
    path: "/feemodule/feepaymentreport",
    exact: false,
    element: <FeePaymentReport />,
  },
  {
    id: 1570,
    path: "/certificates/generate",
    exact: false,
    element: <GenerateCertificate />,
  },
   {
    id: 156,
    path: "/exam/examupload",
    exact: false,
    element: <Bulkexamupload />,
  },
  {
    id: 157,
    path: "/transport/vehiclestage",
    exact: false,
    element: <VehicleStage />,
  },
  {
    id: 158,
    path: "/communication/audiosms",
    exact: false,
    element: <Audiosms />,
  },
  {
    id: 159,
    path: "/communication/smslist",
    exact: false,
    element: <ListSms />,
  },
  {
    id: 160,
    path: "/attendance/notificationlist",
    exact: false,
    element: <Notificationlist />,
  },
  {
    id: 161,
    path: "/attendance/classwiseattendance",
    exact: false,
    element: <Classwiseattendance />,
  },

  // RFID routes
  { id: 170, path: "/rfid/scan", exact: false, element: <ScanCard /> },

  // Payroll Module
  { id: 220, path: "/payroll/salary-components", exact: false, element: <SalaryComponents /> },
  { id: 221, path: "/payroll/salary-structure",  exact: false, element: <SalaryStructure /> },
  { id: 222, path: "/payroll/generate",          exact: false, element: <GeneratePayroll /> },
  { id: 223, path: "/payroll/list",              exact: false, element: <PayrollList /> },
  { id: 224, path: "/payroll/advance",           exact: false, element: <SalaryAdvance /> },
  { id: 225, path: "/payroll/advance-list",      exact: false, element: <AdvanceList /> },
  { id: 226, path: "/payroll/salary-register",   exact: false, element: <SalaryRegister /> },

  // Accounts Module
  { id: 200, path: "/accounts/account-groups",    exact: false, element: <AccountGroups /> },
  { id: 201, path: "/accounts/ledgers",           exact: false, element: <LedgerMaster /> },
  { id: 202, path: "/accounts/receipt-voucher",   exact: false, element: <VoucherEntry /> },
  { id: 203, path: "/accounts/payment-voucher",   exact: false, element: <VoucherEntry /> },
  { id: 204, path: "/accounts/journal-voucher",   exact: false, element: <VoucherEntry /> },
  { id: 205, path: "/accounts/contra-voucher",    exact: false, element: <VoucherEntry /> },
  { id: 206, path: "/accounts/voucher-list",      exact: false, element: <VoucherList /> },
  { id: 207, path: "/accounts/day-book",          exact: false, element: <DayBook /> },
  { id: 208, path: "/accounts/ledger-report",     exact: false, element: <LedgerReport /> },
  { id: 209, path: "/accounts/trial-balance",     exact: false, element: <TrialBalance /> },
  { id: 210, path: "/accounts/profit-loss",       exact: false, element: <ProfitLoss /> },
  { id: 211, path: "/accounts/balance-sheet",     exact: false, element: <BalanceSheet /> },
  { id: 212, path: "/communication/notificationlist", exact: false, element: <AudioNotificationList /> },
  { id: 230, path: "/reports/masterreport", exact: false, element: <MasterReport /> },
  { id: 231, path: "/reports/timetablereport", exact: false, element: <TimetableReport /> },
  { id: 232, path: "/reports/idcardreport", exact: false, element: <IdCardReport /> },
  { id: 233, path: "/reports/aluminireport", exact: false, element: <AluminiReport /> },
  { id: 234, path: "/reports/workerreport", exact: false, element: <WorkerReport /> },
  { id: 235, path: "/reports/visitorreport", exact: false, element: <VisitorReport /> },
  { id: 236, path: "/reports/complaintreport", exact: false, element: <ComplaintReport /> },
  { id: 237, path: "/reports/admissionenquiryreport", exact: false, element: <AdmissionEnquiryReport /> },
  { id: 238, path: "/reports/hostelreport", exact: false, element: <HostelReport /> },
  { id: 239, path: "/reports/calendarreport", exact: false, element: <CalendarReport /> },
  { id: 240, path: "/reports/circularreport", exact: false, element: <CircularReport /> },
  { id: 241, path: "/reports/certificatereport", exact: false, element: <CertificateReport /> },
];
export default {
  dashboardroutes,
};
